<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
            (click)="goBack()"></button>
    </ng-template>
</p-toolbar>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>
    <!-- 
        <ng-template pTemplate="header">Consulta EPG</ng-template>
    -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <div class="card">
                <div class="p-fluid">

                    <div class="subTitle">
                        <label for="opt">{{translations.lbl_zone}}</label>
                        <p-dropdown [options]="listZones" [(ngModel)]="selectedZone" optionLabel="descri"
                            [showClear]="true" placeholder="{{translations.lbl_select}} {{translations.lbl_zone}}"
                            (onChange)="loadNatios($event)"></p-dropdown>
                    </div>

                    <div class="subTitle">
                        <label for="opt">{{translations.lbl_national}}</label>
                        <p-dropdown [options]="listNatio" [(ngModel)]="selectedNatio" optionLabel="descri"
                            [showClear]="true" placeholder="{{translations.lbl_select}} {{translations.lbl_natio}}"
                            (onChange)="loadLocals($event)"></p-dropdown>
                    </div>
                    <div class="subTitle">
                        <label for="opt">{{translations.lbl_local}}</label>
                        <p-dropdown [virtualScroll]="true" [options]="listLocal" [(ngModel)]="selectedLocal"
                            itemSize="30" optionLabel="descri" [showClear]="true"
                            placeholder="{{translations.lbl_select}} {{translations.lbl_local}}"></p-dropdown>
                    </div>
                    <div class="subTitle">
                        <label for="opt">{{translations.lbl_status}}</label>
                        <p-dropdown [virtualScroll]="true" [options]="listSchoolStatus"
                            [(ngModel)]="selectedSchoolStatus" itemSize="30" optionLabel="value" [showClear]="true"
                            (onChange)="search()"></p-dropdown>
                    </div>
                </div>
                <div class="buttonSearch">
                    <div></div>
                    <button [ngClass]="'uppercase-text'" pButton pRipple label="{{translations.lbl_search}}" class="p-button-info"
                        icon="pi pi-search" (click)="search()"></button>
                </div>
            </div>
        </div>
    </div>


    <p-table #dt [value]="lstSchoolsFpg" [rows]="10" [paginator]="true"
        [globalFilterFields]="['schoolFPG.name','statusName','enrollNum','guideName','mateGuideName','wrksStrDate','wrksTeacher','contact','localName']"
        [rowHover]="true" dataKey="guideId" styleClass="p-datatable-customers"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
        [showCurrentPageReport]="true" responsive="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{translations.lbl_list}} {{translations.lbl_sch_for_prepar_guid}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>

            <span class="p-input-icon-left">


                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>

                <th pSortableColumn="schoolFPG.name">{{translations.lbl_name}}<p-sortIcon field="name"></p-sortIcon></th>
                <th pSortableColumn="year">{{translations.lbl_year}}-{{translations.lbl_period}}<p-sortIcon field="year"></p-sortIcon></th>
                <th pSortableColumn="enrollNum">{{translations.lbl_number}} {{translations.lbl_future_guide}}<p-sortIcon
                        field="stage"></p-sortIcon></th>
                <th pSortableColumn="guideName">{{translations.lbl_guide}}<p-sortIcon field="strDate"></p-sortIcon></th>
                <th pSortableColumn="mateGuideName">{{translations.lbl_email}}<p-sortIcon field="wrksName"></p-sortIcon></th>
                <th pSortableColumn="wrksStrDate">{{translations.lbl_stage}}<p-sortIcon field="wrksStrDate"></p-sortIcon></th>
                <th pSortableColumn="wrksTeacher">{{translations.lbl_local}}<p-sortIcon field="wrksTeacher"></p-sortIcon></th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr>
                <td>{{data.schoolFPG.name}}</td>
                <!-- <td>{{verifyStatus(data?.wrks01,data?.wrks02,data?.wrks03)}}</td> -->
                <td>{{data.schoolFPG.year}}-{{data.schoolFPG.period}}</td>
                <td>{{data.enrollNum }}</td>
                <td>{{data.guideName}}</td>
                <td> {{data.wrks01? data.wrks01.gui.email : 'S/N'}} </td>
                <td> {{data.currentStage ? data.currentStage : 'S/N'}} </td>
                <td> {{data.storeName ? data.storeName : 'S/N'}} </td>

            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                {{translations.lbl_total}} {{lstSchoolsFpg ? lstSchoolsFpg.length : 0 }}
                {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>



</p-fieldset>